import React from 'react';
import ReactDOM from 'react-dom';
import 'moment/locale/th'; // ลงทะเบียน locale th ที่ root — craco IgnorePlugin ตัด locale อื่นทั้งหมด
import './tailwind.css';

import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import reducers from './reducers';
import { GoogleOAuthProvider } from "@react-oauth/google";

import { renderStudentRoutes } from './routes.student';
import { initSimulatedClock } from './simulated-clock';
import SimulatedClockBanner from './components/SimulatedClockBanner';

// ต้องอ่าน ?now= ก่อน render — request แรกของหน้าจะได้แนบเวลาจำลองไปด้วย (staging/dev เท่านั้น)
const simulatedNow = initSimulatedClock();

// state เดิมถือของ non-serializable (Date ใน user/tickets) + array ใหญ่ (courses)
// — ปิด dev check ของ RTK ไว้ก่อน กัน warning สแปม/ช้า; devtools ได้มากับ configureStore แล้ว
const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }),
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <GoogleOAuthProvider
        clientId="317231936776-dn5n7job9dpliv8fsp97r4lcqam71l5s.apps.googleusercontent.com">
        <SimulatedClockBanner simulatedNow={simulatedNow} />
        {renderStudentRoutes()}
      </GoogleOAuthProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
